import styled from "styled-components";

export const FormWrapper = styled.form`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    max-width: 100%;
    margin: auto;
`;

export const Button = styled.button`
    padding: 10px;
    background-color: #007bff;
    margin-top: 5px;
    width: 100%;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    &:hover {
        background-color: #0056b3;
    }
`;

export const TicketOption = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 400px;
`;

export const Total = styled.h4`
    margin-top: 20px;
    font-size: 1.2em;
    font-weight: bold;
`;
